export default "__VITE_ASSET__NVKz1sL4__"